import script from "./privacy-policy.vue?vue&type=script&setup=true&lang=js"
export * from "./privacy-policy.vue?vue&type=script&setup=true&lang=js"

import "./privacy-policy.vue?vue&type=style&index=0&id=e2eae718&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2eae718"]])

export default __exports__